// import React, { useEffect, useState, useRef } from 'react';
import React, { FC, useEffect, useState } from 'react';
// eslint-disable-next-line import/no-extraneous-dependencies
// import { LogoLink, LogoWrapper, LogoImage, Video } from './styled';
import { LogoLink, LogoWrapper, LogoImageWrapper } from './styled';
import ImageWithFallback from '../../ImageWithFallback';

interface Props {
  logo?: { src: string | null; alt: string | null };
  animatedLogo?: { src: string | null };
  locale: string;
}

// const LogoComponent = ({ logo, animatedLogo, locale }) => {
const LogoComponent: FC<Props> = ({ logo, animatedLogo, locale }) => {
  // const videoRef = useRef(null);
  const [hasScrolled, setHasScrolled] = useState(false);
  // const [videoReady, setVideoReady] = useState(false);
  // const [showVideo, setShowVideo] = useState(false);
  console.log(animatedLogo);

  useEffect(() => {
    const handleScroll = () => {
      if (!hasScrolled) {
        setHasScrolled(true);
        window.removeEventListener('scroll', handleScroll);
      }
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [hasScrolled]);

  // useEffect(() => {
  //   if (!hasScrolled) return () => {};

  //   const checkVideoReady = () => {
  //     const video = videoRef.current;
  //     if (video && video.readyState >= 2) {
  //       setVideoReady(true);
  //     }
  //   };

  //   const timeout = setTimeout(checkVideoReady, 500);

  //   return () => clearTimeout(timeout);
  // }, [hasScrolled]);

  // useEffect(() => {
  //   if (!videoReady) return () => {};

  //   let interval;
  //   const video = videoRef.current;
  //   if (videoReady) {
  //     setShowVideo(true);
  //     video.currentTime = 0;
  //     video.play();

  //     interval = setInterval(() => {
  //       if (video) {
  //         setShowVideo(true);
  //         video.currentTime = 0;
  //         video.play();
  //       }
  //     }, 30000);
  //   }

  //   return () => clearInterval(interval);
  // }, [videoReady]);
  const href = locale === 'en' ? '/' : `/${locale}/`;

  return (
    <LogoLink href={href}>
      <LogoWrapper>
        <LogoImageWrapper>
          <ImageWithFallback src={logo?.src} alt={logo?.alt} />
        </LogoImageWrapper>
        {/* {(!hasScrolled || !showVideo) && (
          <LogoImage src={logo.src} alt={logo.alt} />
        )}

        {hasScrolled && (
          <Video
            ref={videoRef}
            src={animatedLogo.src}
            autoPlay
            muted
            playsInline
            disablePictureInPicture
            display={showVideo ? 'block' : 'none'}
          />
        )} */}
      </LogoWrapper>
    </LogoLink>
  );
};

export default LogoComponent;
